// extracted by mini-css-extract-plugin
module.exports = {"docContent":"Documentation_docContent__1xkAM"};